import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  inject
} from "@angular/core";
import { VisitStore } from "@app/services/store/visit-store";
import { ROUTE_ANIMATIONS_ELEMENTS, routeAnimations } from "@app/core";
import { PageEvent } from "@angular/material/paginator";
import { VisitTableViewerComponent } from "@app/view/data-view/visit-table-viewer/visit-table-viewer.component";
import { Router } from "@angular/router";
import { BookingNavigationService } from "@app/services/navigation/booking-navigation.service";
import { MatTabChangeEvent, MatTabGroup, MatTab } from "@angular/material/tabs";
import {
  ColumnConfig,
  DateColumnConfig,
  WidgetColumnConfig
} from "@bryntum/grid-thin";
import { MatProgressBar } from "@angular/material/progress-bar";
import { VisitTableViewerComponent as VisitTableViewerComponent_1 } from "../../data-view/visit-table-viewer/visit-table-viewer.component";
import { AsyncPipe } from "@angular/common";

@Component({
  selector: "app-booking-home",
  templateUrl: "./booking-home.component.html",
  styleUrls: ["./booking-home.component.scss"],
  animations: [routeAnimations],
  imports: [
    MatProgressBar,
    MatTabGroup,
    MatTab,
    VisitTableViewerComponent_1,
    AsyncPipe
  ]
})
export class BookingHomeComponent implements OnInit, AfterViewInit {
  visitStore = inject(VisitStore);
  router = inject(Router);
  private bookingNavigationService = inject(BookingNavigationService);

  // isAdmin: boolean = false;
  // isLoading: boolean = false;
  isError: boolean = false;
  public length = 0;
  public pageSize = 6;
  public pageSizeOptions = [6, 12, 24];
  public pageEvent: PageEvent = {
    length: 0,
    pageIndex: 0,
    pageSize: 0,
    previousPageIndex: 0
  };

  public routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  errorMessage: string;
  columns: (ColumnConfig | DateColumnConfig | WidgetColumnConfig)[] = [
    {
      field: "job.externalJobReference",
      text: "Job",
      flex: 1,
      editor: false,
      sortable: true
    },
    {
      field: "job.externalCaseReference",
      text: "Case",
      flex: 1,
      editor: false,
      sortable: true
    },
    {
      field: "visitStatus",
      text: "Status",
      flex: 1,
      editor: false,
      hidden: true
    },
    {
      field: "job.priority.description",
      text: "Priority",
      flex: 1,
      editor: false,
      hidden: false,
      sortable: true
    },
    {
      field: "visitType.description",
      text: "Type",
      filterable: true,
      flex: 1,
      editor: false,
      sortable: true
    },
    {
      field: "job.planningWindowEnd",
      text: "Due",
      filterable: true,
      flex: 1,
      editor: false,
      format: "DD/MM/YYYY HH:mm",
      type: "date",
      sortable: true
    },
    {
      type: "widget",
      text: "Book",
      width: 110,
      widgets: [
        {
          type: "button",
          color: "blue",
          cls: "b-raised",
          icon: "b-icon b-fa-clock",
          text: "Book",
          flex: 1,
          onClick: ({ source: btn }) => {
            const { record } = btn.cellInfo;
            // Store the current route so booking components can return here
            this.bookingNavigationService.setOriginalRoute("/booking");
            this.router.navigate(["/booking/visit/", record.id]).then();
            // Toast.show(`Booking a flight to ${record.city}`);
          }
        }
      ]
    }
  ];

  @ViewChild("visitTableViewer", { static: false })
  visitTableViewer: VisitTableViewerComponent;

  followOnCount: any = "";

  refresh() {
    console.log("refreshing visit list");
  }

  ngOnInit() {
    this.refresh();
  }

  retryLoad() {
    console.log("Retrying load");
    this.refresh();
  }

  selectPage() {
    this.refresh();
  }

  gridChanged() {}

  ngAfterViewInit(): void {
    if (this.visitTableViewer.grid) {
      this.visitTableViewer.grid?.store.removeAll(true);

      this.visitTableViewer.grid.store.clearFilters(true);
      this.visitTableViewer.grid.store.addFilter({
        property: "visitStatus",
        value: "REFERRED"
      });
      this.visitTableViewer.grid.store.addFilter({
        property: "job.externalProjectReference",
        operator: "empty",
        value: "any"
      });
      this.visitTableViewer.grid.store.performFilter(false);
    }
  }

  referMode() {
    // console.log("Entering refer mode");
    this.visitTableViewer.grid.store.removeAll(false);

    this.visitTableViewer.grid.store.clearFilters(true);
    this.visitTableViewer.grid.store.addFilter({
      property: "visitStatus",
      value: "REFERRED"
    });
    this.visitTableViewer.grid.store.addFilter({
      property: "job.externalProjectReference",
      operator: "empty",
      value: "any"
    });
    this.visitTableViewer.grid.store.performFilter(false);
  }

  newMode() {
    console.log("Entering new mode");
    this.visitTableViewer.grid.store.removeAll(false);

    this.visitTableViewer.grid.store.clearFilters(true);
    this.visitTableViewer.grid.store.addFilter({
      property: "visitStatus",
      value: "NEW"
    });
    this.visitTableViewer.grid.store.addFilter({
      property: "job.externalProjectReference",
      operator: "empty",
      value: "any"
    });
    this.visitTableViewer.grid.store.performFilter(false);
  }

  tabChange($event: MatTabChangeEvent) {
    console.log("Tab change event");
    if ($event.index === 0) this.referMode();
    else this.newMode();
  }
}
